import { Licensing } from '@adaptiva/core/licensing';
import { Pipe, PipeTransform } from '@angular/core';
import { IProductTrialDisplay } from '../interfaces';

@Pipe({ name: 'adaAiProductTrialDisabled' })
export class AiProductTrialDisabledPipe implements PipeTransform {

	public transform(_product: IProductTrialDisplay): boolean {
		return _product.state === Licensing.States.ENABLED
			|| _product.state === Licensing.States.ENABLING
			|| _product.state === Licensing.States.REMOVING
			|| _product.state === Licensing.States.DISABLING;
	}

}
